import styled from "styled-components";

const StyledHeader = styled.div`
  background: rgba(0, 120, 231, 0.04);
  .container {
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    float: left;
    cursor: pointer;
    & span {
      font-weight: bold;
      font-size: 34px;
      line-height: 34px;
      color: ${({ theme }) => theme.colors.primary};
      cursor: pointer;
    }
  }
  .styled-button {
    padding: 10px 30px 10px 30px;
    background: ${({ theme }) => theme.colors.primary};
    color: white;
    border-radius: 32px;
    border: none;
    cursor: pointer;
    font-family: Sansation;
  }
`;

export default StyledHeader;
